module.exports = __webpack_public_path__ + "img/1575380475.e3f60c06.jpg";